import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import { selectUserContext } from './user-context.selectors';
import { selectIsAuthorized } from './auth.selectors';

import {
  authFeature,
  AuthState,
  AuthEffects,
  globalSpinnerFeature,
  GlobalSpinnerState,
  localStorageSync,
  RouterEffects,
  routerFeature,
  RouterReducerState,
  userPreferencesFeature,
  UserPreferencesState,
} from '@iss/wo-common/ngrx';

export type AppState = Readonly<{
  [routerFeature.name]: RouterReducerState;
  [globalSpinnerFeature.name]: GlobalSpinnerState;
  [userPreferencesFeature.name]: UserPreferencesState;
  [authFeature.name]: AuthState;
}>;

export const reducers: ActionReducerMap<AppState> = {
  [routerFeature.name]: routerFeature.reducer,
  [globalSpinnerFeature.name]: globalSpinnerFeature.reducer,
  [userPreferencesFeature.name]: userPreferencesFeature.reducer,
  [authFeature.name]: authFeature.reducer,
};

export const effects = [ RouterEffects, AuthEffects ];

export const metaReducers: MetaReducer<AppState>[] = [
  localStorageSync<AppState>({
    keys: [ userPreferencesFeature.name ],
    serializationKey: 'root',
  }),
];

export {
  authFeature,
  authActions,
  globalSpinnerFeature,
  globalSpinnerActions,
  userPreferencesActions,
  userPreferencesFeature,
} from '@iss/wo-common/ngrx';

export {
  appContextActions,
  appContextFeature,
  AppContextStateModule,
} from './app-context';

export const authSelectors = {
  selectIsAuthorized,
};

export const userContextSelectors = {
  selectUserContext,
};
